import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Learn from "@/pages/Learn";

export const Route = createFileRoute("/learn/")({
  head: () => seoHead("/learn/"),
  component: Learn,
});
